var React = require('react');

function DArr (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_5","data-name":"Group 5","transform":"translate(0.585 31.927) rotate(-90)"},[React.createElement("line",{"id":"Line_19","data-name":"Line 19","x1":"31.038","transform":"translate(0.889 7.776)","fill":"none","stroke":"#000","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_5","data-name":"Path 5","d":"M5.712,14.927,0,7.911,5.712,0","fill":"none","stroke":"#000","strokeWidth":"2","key":1})]));
}

DArr.defaultProps = {"width":"16.144","height":"33.186","viewBox":"0 0 16.144 33.186"};

module.exports = DArr;

DArr.default = DArr;
